import { FILES } from '@/api'

const uploadUrl = () => {
  return process.env.VUE_APP_API_URL + FILES
}

export default {
  uploadUrl
}
